<template>
  <div class="audience-analysis">
    <div class="panel-header">
      <h3 class="panel-header__title">受众分析</h3>
      <span class="panel-header__subtitle">AUDIENCE ANALYSIS</span>
      <a class="panel-header__export" v-if="exportUrl" :href="exportUrl">导出</a>
    </div>
    <div class="panel-content">
      <h3 class="panel-content__title">
        受众分析
      </h3>
      <div class="panel-content__select-wrap">
        <div class="panel-content__select-list">
          <up-date-picker
            v-model="params.date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </up-date-picker>
        </div>
        <div class="panel-content__select-list">
          <up-select class="panel-content__select-item" v-model="params.view_type" :data="views" :key-value="['name', 'id']" placeholder="请选择视图"></up-select>
          <up-select v-model="params.dimension_type" multiple collapse-tags :data="dimensions" :key-value="['name', 'id']" placeholder="请选择维度" @change="handleDimensionTypeChange"></up-select>
        </div>
        <div class="panel-content__select-list">
          <up-row type="flex">
            <up-col :span="6" v-show="!!params.view_type && platform !== 'ad-user'">
              <span class="panel-content__label">账户名称</span>
              <up-input style="width: auto" class="panel-content__select-item" v-model="params.account_name"></up-input>
            </up-col>
            <up-col :span="6" v-show="[2, 3, 4].includes(params.view_type)">
              <span class="panel-content__label">广告组名称</span>
              <up-input style="width: auto" class="panel-content__select-item" v-model="params.order_name"></up-input>
            </up-col>
            <up-col :span="6" v-show="[3, 4].includes(params.view_type)">
              <span class="panel-content__label">计划名称</span>
              <up-input style="width: auto" class="panel-content__select-item" v-model="params.ad_name"></up-input>
            </up-col>
            <up-col :span="6" v-show="params.view_type === 4">
              <span class="panel-content__label">创意名称</span>
              <up-input style="width: auto" class="panel-content__select-item" v-model="params.creative_name"></up-input>
            </up-col>
          </up-row>
        </div>
        <div class="panel-content__select-list">
          <span class="panel-content__select-item" v-show="params.dimension_type.includes(1)">
            <span class="panel-content__label">年龄</span>
            <audience-analysis-select class="fl" v-model="params.age_type" :data="ages" @selected="value => handleSelect(value, 'age_type')"></audience-analysis-select>
          </span>
          <span class="panel-content__select-item" v-show="params.dimension_type.includes(2)">
            <span class="panel-content__label">性别</span>
            <audience-analysis-select class="fl" v-model="params.gender_type" :data="genders" @selected="value => handleSelect(value, 'gender_type')"></audience-analysis-select>
            <!-- <up-select class="panel-content__select-item" v-model="gender" :data="genders" :key-value="['name', 'id']"></up-select> -->
          </span>
          <span class="panel-content__select-item" v-show="params.dimension_type.includes(3)">
            <span class="panel-content__label">收入信息</span>
            <audience-analysis-select class="fl" v-model="params.income_type" :data="incomes" @selected="value => handleSelect(value, 'income_type')"></audience-analysis-select>
            <!-- <up-select class="panel-content__select-item" v-model="income" :data="incomes" :key-value="['name', 'id']"></up-select> -->
          </span>
          <up-button class="ml10" type="primary" @click="handleSearch({ prop:'', order: '' })">查询</up-button>
        </div>
      </div>
      <div class="panel-content__table-wrap">
        <up-table ref="upTable" show-overflow-tooltip :page="page" :sortColumns="sortColumns" :widthColumns="{ account_id: 100, account_name: 160, order_id: 160, order_name: 200, income: 120, display_pv: 100, click_pv: 100, ctr: 100, cpm: 160, cpc: 100 }" pagination @sort-change="handleSortChange" @up:current-change="handleSearch" @up:size-change="handleSearch" align="center"></up-table>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'querystring'
// import { get } from '@/manager/http'
import AudienceAnalysisSelect from './select'
import { getDiffDate } from '@/global/util/date'
import { BASE_URL } from '@/global/util/constants'
import { mapActions } from 'vuex'

export default {
  name: 'audience-analysis',
  components: {
    AudienceAnalysisSelect
  },
  data () {
    return {
      platform: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      params: {
        date: getDiffDate(-1, { result: [] }),
        view_type: 2,
        dimension_type: [1, 2, 3],
        account_name: '',
        order_name: '',
        ad_name: '',
        creative_name: '',
        age_type: [],
        gender_type: [],
        income_type: [],
      },
      sort: {
        prop: '',
        order: ''
      },
      sortColumns: [],
      page: new this.$page(),
      views: [],
      dimensions: [],
      originalDimensionType: [],
      ages: [],
      genders: [],
      incomes: []
    }
  },
  computed: {
    exportUrl () {
      return BASE_URL + `/${this.platform}/analysis/list?` + qs.stringify(this.getRequestParams({ export: true }))
    }
  },
  methods: {
    ...mapActions('audience', ['getOptions', 'getList']),
    handleSelect ({ value, all }, type) { },
    handleDimensionTypeChange (value, ...args) {
      if (value.length === 0) {
        this.params.dimension_type = this.originalDimensionType
      }
      this.originalDimensionType = value
    },
    handleSortChange ({ column, prop, order } = {}) {
      this.sort.prop = prop
      this.sort.order = order
      this.handleSearch({ prop, order })
    },
    getRequestParams ({ prop = this.sort.prop, order = this.sort.order, export: isExport } = {}) {
      const { date, dimension_type, age_type, gender_type, income_type, ...rest } = this.params
      const { currentPage, pageSize } = this.page

      const params = {
        ...rest,
        dimension_type: dimension_type.join(","),
        age_type: age_type.includes('all') ? 'all' : age_type.join(','),
        gender_type: gender_type.includes('all') ? 'all' : gender_type.join(','),
        income_type: income_type.includes('all') ? 'all' : income_type.join(','),
        start_time: date[0],
        end_time: date[1],
        page: currentPage,
        size: pageSize
      }

      if (prop && order) {
        params.sort_by = prop
        params.ascending = order === 'ascending'
      }
      if (isExport) {
        params.is_export = 1
      }

      return params
    },
    async handleSearch ({ prop, order } = {}) {
      this.page.loading = true
      if (!(prop && order)) this.$refs.upTable.clearSort()
      const { data: { header = {}, data = [], count: total = 0 } } = await this.getList({ platform: this.platform, params: this.getRequestParams({ prop, order }) })
      this.sortColumns = Object.keys(header)
      this.page.setData({ header, data, total })
    }
  },
  async created () {
    this.platform = this.$route.meta.platform

    const res = await this.getOptions({ platform: this.platform, field: 'all' })
    if (res.code === 1) {
      const { age, dimension, gender, income, view } = res.data
      this.ages = age
      this.dimensions = dimension
      this.genders = gender
      this.incomes = income
      this.views = view

      this.handleSearch()
    }
  }
}
</script>

<style lang="scss">
.el-select-dropdown__item {
  &.selected,
  &:hover,
  &.hover {
    .audience-analysis__checkbox {
      .el-checkbox__label {
        color: white;
      }
    }
  }
}
@include b(audience-analysis) {
  @include e(checkbox) {
    height: 100%;
    text-align: left;

    .el-checkbox {
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;

      .el-checkbox__label {
        flex: 1;
      }
    }
  }

  @include e(select) {
    &.el-select {
      .el-tag__close {
        display: none;
      }
    }
  }
}
</style>
